"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.DateFilterFormWrapper = void 0;
var tslib_1 = require("tslib");
// (C) 2007-2019 GoodData Corporation
var react_1 = tslib_1.__importDefault(require("react"));
var classnames_1 = tslib_1.__importDefault(require("classnames"));
exports.DateFilterFormWrapper = function (_a) {
    var children = _a.children, isMobile = _a.isMobile, className = _a.className, restProps = tslib_1.__rest(_a, ["children", "isMobile", "className"]);
    return (react_1.default.createElement("div", tslib_1.__assign({ className: classnames_1.default(className, "gd-date-filter-form-wrapper", !isMobile && "gd-date-filter-form-wrapper-desktop") }, restProps),
        react_1.default.createElement("div", { className: "gd-date-filter-form-wrapper-inner" }, children)));
};
//# sourceMappingURL=DateFilterFormWrapper.js.map